import React, { useState, useEffect } from 'react';
import { Space, Popover, Modal, Input, Table, Button, Tooltip, Image, Skeleton } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';

export default function YieldTable({ data, header }) {

    const [state, setState] = useState({
        searchText: '',
        searchedColumn: '',
    });

    var searchInput;


    const getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <Input
              ref={node => {
                searchInput = node;
              }}
              placeholder={`Search ${dataIndex}`}
              value={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
              style={{ marginBottom: 8, display: 'block' }}
            />
            <Space>
              <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                // size="small"
                style={{ width: 90 }}
              >
                Search
              </Button>
              <Button onClick={() => handleReset(clearFilters)} style={{ width: 90 }}>
                Reset
              </Button>
            </Space>
          </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
          record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => searchInput.select(), 100);
          }
        },
        render: text =>
          state.searchedColumn === dataIndex ? (
            <Tooltip placement="topLeft" title={
              <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[state.searchText]}
                autoEscape
                textToHighlight={text ? text.toString() : ''}
              />
            }>
              <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[state.searchText]}
                autoEscape
                textToHighlight={text ? text.toString() : ''}
              />
            </Tooltip>
          ) : (
            text
          ),
      });

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setState({ searchText: '' });
    };

    function getColumns(array) {
        let currentItems = [];
        for (let i = 0; i < array.length; i++) {
            let mark = typeof (data[0][array[i]])
            let current = {
                title: array[i],
                dataIndex: array[i],
                key: array[i],
                sorter: (a, b) => mark === 'number' ? a[array[i]] - b[array[i]] : a[array[i]].localeCompare(b[array[i]]),
                ellipsis: {
                    showTitle: false,
                },
                ...getColumnSearchProps(array[i]),
            };
            let current2 = {
                title: array[i],
                dataIndex: array[i],
                key: array[i],
                ellipsis: {
                    showTitle: false,
                },
                render: (_, record) => {
                    return (
                      <>{String(record[array[i]]) === "false" ? "FALSE" : "TRUE"}</>
                    );
                  },
            };
            currentItems.push( mark === 'boolean' ? current2 : current)
        }

        return currentItems;
    }

    const [columns, setColumns] = useState(getColumns(header));
    const [isLoaded, setisLoaded] = useState(false);


    useEffect(() => {
        if (columns !== undefined && columns.length !== 0) {
            setisLoaded(true);
        }
    }, [columns])

    return (
        <>
        {
            isLoaded
                ?
                <Table
                    bordered
                    rowKey={header[0]}
                    columns={columns}
                    dataSource={data}
                    // loading={loading}
                    pagination={data.length > 10 ? undefined : false}
                />
                :
                <Skeleton loading active />
        }
        </>
    );
}
